import { render, staticRenderFns } from "./ProjectPlan.vue?vue&type=template&id=718d6bcc&"
import script from "./ProjectPlan.ts?vue&type=script&lang=ts&"
export * from "./ProjectPlan.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports